import { render, staticRenderFns } from "./ScoringCriterionForm.vue?vue&type=template&id=2eda27cc&"
import script from "./ScoringCriterionForm.vue?vue&type=script&lang=js&"
export * from "./ScoringCriterionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports